<template>
  <div class="modal-content">
    <form novalidate @submit.prevent="callRequest" id="call-request-modal-form">
      <ErrorMessage v-if="errorMessage" :error-message="errorMessage" />

      <p class="modal-text">Представьтесь и мы Вам перезвоним</p>

      <div class="form-group">
        <Input
          ref="nameInput"
          type="text"
          placeholder="Ваше имя"
          v-model.trim="name"
          :invalid="showErrors && $v.name.$error"
          @keydown.space.prevent
        />
        <div v-if="showErrors && !$v.name.required" class="invalid-feedback">
          Поле обязательно для заполнения
        </div>
      </div>

      <div class="form-group">
        <Input
          type="tel"
          placeholder="Ваш номер телефона"
          v-model="phone"
          :invalid="showErrors && $v.phone.$error"
          :mask="{
            mask: '+ 375 (99) 999-99-99',
            placeholder: '_',
            showMaskOnHover: false,
          }"
          @keydown.space.prevent
        />
        <div v-if="showErrors && !$v.phone.required" class="invalid-feedback">
          Поле обязательно для заполнения
        </div>
        <div
          v-else-if="showErrors && !$v.phone.validatePhone"
          class="invalid-feedback"
        >
          Некорректный номер телефона
        </div>
      </div>

      <Button
        class="button"
        variant="gradient"
        type="submit"
        :title="isDisabled ? 'Заполните обязательные поля' : ''"
      >
        Отправить
      </Button>

      <Checkbox v-model="accepted" :highlight-key="checkboxHighlightKey">
        <span @click.stop class="checkbox-text">
          Нажимая “Отправить” я соглашаюсь на обработку моих персональных данных
          в соответствии с
          <router-link
            exact
            :to="privacyPolicyPath"
            class="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Политикой конфиденциальности
          </router-link>
        </span>
      </Checkbox>
    </form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ErrorMessage from "@/components/common/ErrorMessage";
import Input from "@/components/homePage/Input";
import Button from "@/components/homePage/Button";
import Checkbox from "@/components/homePage/Checkbox";
import api from "@/application";
import { privacyPolicyPath } from "@/router/privacyPolicy";

export default {
  name: "CallRequestModal",
  components: { ErrorMessage, Input, Button, Checkbox },
  data() {
    return {
      name: "",
      phone: "",
      accepted: false,
      isRequesting: false,
      errorMessage: null,
      showErrors: false,
      privacyPolicyPath,
      checkboxHighlightKey: 0,
    };
  },
  validations: {
    name: { required },
    phone: {
      required,
      validatePhone: function (phone) {
        return /\+ 375 \(\d\d\) \d\d\d-\d\d-\d\d/.test(phone);
      },
    },
    accepted: { required },
  },
  computed: {
    isDisabled() {
      return this.$v.$invalid || !this.accepted || this.isRequesting;
    },
  },
  methods: {
    async callRequest() {
      this.showErrors = true;
      this.$v.$touch();

      if (!this.accepted) {
        this.checkboxHighlightKey++;
      }

      if (this.isDisabled) return;

      this.isRequesting = true;
      this.errorMessage = null;

      try {
        await api.mail.sendMessageOnOrderedCall({
          contactName: this.name,
          phone: this.phone,
          callType: "CALLBACK",
        });

        this.$toast.success("Спасибо! Мы свяжемся с Вами в ближайшее время!");
        this.name = "";
        this.phone = "";
        this.accepted = false;
        this.showErrors = false;
        this.$v.$reset();
        this.$modal.container.destroyModal();
      } catch (e) {
        this.errorMessage = e.message || "Ошибка при отправке формы";
      } finally {
        this.isRequesting = false;
      }
    },
  },
  mounted() {
    this.$refs.nameInput.focus();
  },
};
</script>

<style lang="less" scoped>
.modal-content {
  form {
    display: flex;
    flex-direction: column;
    gap: 25px;

    .form-group {
      margin: 0;
    }

    .invalid-feedback {
      color: #f84242;
      font-size: 14px;
    }

    .button {
      height: 60px;
      font-family: Montserrat;
      font-weight: 600;
      font-size: 20px;
      line-height: 1;
    }

    .modal-text {
      color: #fff;
      font-size: 16px;
      margin-bottom: 10px;
      text-align: center;
    }
  }

  .checkbox-text {
    font-family: Montserrat;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.2;
    color: white;

    .link {
      color: #a5d8ff;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
